import type { Timestamp } from "firebase/firestore";
import type { ShipmentLocation, ShipmentStatus } from "./types";

export function formatUGX(value?: number | null): string {
  const n = Math.round(Number(value ?? 0));
  return `UGX ${n.toLocaleString("en-US")}`;
}

export function toDate(ts?: Timestamp | Date | null): Date | null {
  if (!ts) return null;
  if (ts instanceof Date) return ts;
  if (typeof (ts as Timestamp).toDate === "function") return (ts as Timestamp).toDate();
  return null;
}

export function formatDate(ts?: Timestamp | Date | null): string {
  const d = toDate(ts);
  if (!d) return "—";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(ts?: Timestamp | Date | null): string {
  const d = toDate(ts);
  if (!d) return "—";
  return `${formatDate(d)} · ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
}

export function formatPhone(phone?: string | null): string {
  return phone?.trim() || "—";
}

export function normalizeUgandaPhone(input: string): string {
  const digits = input.replace(/[^\d+]/g, "");
  if (digits.startsWith("+256")) return digits;
  if (digits.startsWith("256")) return `+${digits}`;
  if (digits.startsWith("0")) return `+256${digits.slice(1)}`;
  return `+256${digits}`;
}

export function isValidUgandaPhone(input: string): boolean {
  return /^\+256\d{9}$/.test(normalizeUgandaPhone(input));
}

export function locationLabel(loc?: ShipmentLocation | string | null): string {
  if (!loc) return "—";
  if (typeof loc === "string") return loc;
  if (loc.address) return loc.address;
  const { latitude, longitude } = loc.coordinate;
  return `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
}

export const STATUS_LABELS: Record<ShipmentStatus, string> = {
  searching: "Searching",
  offered: "Offered to rider",
  accepted: "Accepted",
  en_route_pickup: "En route to pickup",
  arrived_pickup: "At pickup",
  picked_up: "Picked up",
  in_transit: "In transit",
  arrived_dropoff: "At destination",
  delivered: "Delivered",
  cancelled: "Cancelled",
  expired: "Expired",
  failed: "Failed",
};
